import { useState } from 'react'

import { cn } from '@/lib/utils.ts'

import { useSubscription } from '@/hooks/useSubscription.ts'
import AlertIcon from '@/images/alert-icon.svg?react'
import { GlobalPubSub } from '@/utils/pubsub.ts'

export const NetworkToast = () => {
  const [isDisplayNetworkError, setIsDisplayNetworkError] = useState(false)

  useSubscription([
    [
      GlobalPubSub.Signals.TOGGLE_NETWORK_ERROR_MESSAGE,
      ((toggleErrorMessage: boolean) => {
        if (window.location.pathname === '/login') return
        setIsDisplayNetworkError(toggleErrorMessage)
      }) as Callback,
    ],
  ])

  if (!isDisplayNetworkError) return null

  return (
    <div
      className={cn(
        'fixed z-50 m-auto w-full left-1/2 -translate-x-1/2 max-[1000px]:top-[116px] top-[76px]',
        'border border-alarm-red-700 bg-alarm-red-50 rounded-sm w-[640px] p-4',
        'animate-slide-in-from-top',
      )}
    >
      <div className="flex flex-row gap-2 justify-start font-EN-KR-sub-heading-bold text-alarm-red-900">
        <AlertIcon />
        <span>Unstable network connection.</span>
      </div>
      <span className="font-EN-KR-body1-regular text-contents-primary">
        Please check your internet connection. Some changes might not have been saved.
      </span>
    </div>
  )
}
